import React, { useState, useEffect } from 'react';
import { TextField, useTheme, useMediaQuery, Box, Button, Typography, Container, Paper, IconButton, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import { ArrowBackOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { messageTemplates } from './messages';

function Replier() {
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [messageType, setMessageType] = useState('');
  const [generatedMessage, setGeneratedMessage] = useState('');
  const [inputsState, setInputsState] = useState({});
  const EVENT_TYPES = ['Événement', 'Mariage', 'Anniversaire','Atelier Cocktails', 'Soirée d’entreprise', 'Fête Privée', 'Fête d’entreprise'];
  const TITLES = ['M.', 'Mme.'];
  const REGLER = ['regler', 'à régler'];
  const PAYMENT_TYPES = ['virement', 'carte Bancarie', 'espèces', 'cheque'];
  const PLATFORMS = ['Star of Service', 'Marriage.net', 'Funbooker', 'Malt', 'Superprof', 'Google', 'Instagram', 'Site', 'Jemepropose', 'LinkedIn'];

  const messageTypeToFields = {
    "Welcome Message": ['Title', 'Name', 'Platform', 'Date', 'EventType'],
    "Full Booked": ['Title', 'Name', 'Platform', 'Date', 'EventType'],
    "Relance Accompte 1": ['Title', 'Name', 'EventType'],
    "Relance Accompte 2": ['Title', 'Name'],
    "Négociation Accepted": ['Title', 'Name'],
    "Négociation Not Accepted": ['Title', 'Name'],
    "Facture Accompte": ['Title', 'Name', 'Regler', 'Payment Type'],
    "Logistique": ['Title', 'Name'],
    "Thanks Service": ['Title', 'Name', 'Date'],
    "Thanks + Payment": ['Title', 'Name', 'Date'],
    "Relance Payment 1": ['Name', 'Date'],
    "Relance Payment 2": ['Name', 'Date'],
  };

  useEffect(() => {
    const initialInputStates = {};
    if (messageTypeToFields[messageType]) {
      messageTypeToFields[messageType].forEach(field => {
        initialInputStates[field] = '';
      });
      setInputsState(initialInputStates);
    } else {
      setInputsState({});
    }
  }, [messageType]);

  const handleInputChange = (name, value) => {
    setInputsState(prevState => ({ ...prevState, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!messageTemplates[messageType]) {
      setGeneratedMessage('Please select a valid message type.');
      return;
    }

    const randomIndex = Math.floor(Math.random() * messageTemplates[messageType].length);
    const reply = messageTemplates[messageType][randomIndex];

    const finalMessage = reply
  
        .replace("{title}", inputsState["Title"])
        .replace("{name}", inputsState["Name"])
        .replace("{date}", inputsState["Date"])
        .replace("{platform}", inputsState["Platform"])
        .replace("{regler}", inputsState["Regler"])
        .replace("{paymentType}", inputsState["Payment Type"])
        .replace("{eventType}", inputsState["EventType"]);
    
      setGeneratedMessage(finalMessage);
  };

    const navigate = useNavigate();

    const copyToClipboard = (e) => {
      const textArea = document.createElement("textarea");
      textArea.value = generatedMessage;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    };

  return (
    <Box m="0 2.5rem">
      <FlexBetween>
        <Header title="" subtitle="Back" />
      </FlexBetween>
      <IconButton
        color="secondary"
        onClick={() => {
          navigate("/apps");
        }}
      >
        <ArrowBackOutlined />
      </IconButton>
      <Container maxWidth="md">
        <Box
          flexDirection="column"
          marginTop={5}
          style={{ minHeight: '70vh' }}
        >
          <Paper elevation={3} style={{ overflow: 'hidden', width: '100%' }}>
            
            <Box p={3}>
              <Header title="Replier 1.0" subtitle="Generate email reply" />
              <FormControl fullWidth variant="outlined" margin="normal" sx={{ marginTop: 5 }}>
                <InputLabel id="message-type-label">Message type</InputLabel>
                <Select
                  labelId="message-type-label"
                  value={messageType}
                  onChange={(e) => setMessageType(e.target.value)}
                  label="Message Type"
                >
                  {Object.keys(messageTypeToFields).map(type => (
                      <MenuItem key={type} value={type}>{type}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              {messageTypeToFields[messageType] && messageTypeToFields[messageType].map((field, index) => {
                if (field === "EventType") {
                  return (
                    <FormControl key={index} fullWidth variant="outlined" margin="normal">
                      <InputLabel>{field}</InputLabel>
                      <Select
                        value={inputsState[field] || ''}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        label={field}
                      >
                        {EVENT_TYPES.map(type => (
                          <MenuItem key={type} value={type}>{type}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                } else if (field === "Title") {
                  return (
                    <FormControl key={index} fullWidth variant="outlined" margin="normal">
                      <InputLabel>{field}</InputLabel>
                      <Select
                        value={inputsState[field] || ''}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        label={field}
                      >
                        {TITLES.map(title => (
                          <MenuItem key={title} value={title}>{title}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                } else if (field === "Platform") {
                  return (
                    <FormControl key={index} fullWidth variant="outlined" margin="normal">
                      <InputLabel>{field}</InputLabel>
                      <Select
                        value={inputsState[field] || ''}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        label={field}
                      >
                        {PLATFORMS.map(platform => (
                          <MenuItem key={platform} value={platform}>{platform}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                } else if (field === "Regler") {
                  return (
                    <FormControl key={index} fullWidth variant="outlined" margin="normal">
                      <InputLabel>{field}</InputLabel>
                      <Select
                        value={inputsState[field] || ''}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        label={field}
                      >
                        {REGLER.map(regler => (
                          <MenuItem key={regler} value={regler}>{regler}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                } else if (field === "Payment Type") {
                  return (
                    <FormControl key={index} fullWidth variant="outlined" margin="normal">
                      <InputLabel>{field}</InputLabel>
                      <Select
                        value={inputsState[field] || ''}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        label={field}
                      >
                        {PAYMENT_TYPES.map(paymentType => (
                          <MenuItem key={paymentType} value={paymentType}>{paymentType}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                } else {
                  return (
                    <TextField
                      key={index}
                      label={field}
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      value={inputsState[field] || ''}
                      onChange={(e) => handleInputChange(field, e.target.value)}
                      required
                    />
                  );
                }
              })}
              
              <Box mt={2} justifyContent="space-between" position="relative">
                <Button
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={handleSubmit}
                  fullWidth={isMobile}
                >
                  Generate Message
                </Button>
                
                {isMobile ? (
                  <Typography
                    sx={{
                      color: theme.palette.grey[500],
                      fontSize: "10px",
                      mt: 1
                    }}
                    align="center"
                  >
                    Powered by KodaWise
                  </Typography>
                ) : (
                  <Box>
                    <Typography
                      style={{
                        position: 'absolute',
                        right: 0,
                        bottom: 3
                      }}
                      sx={{ color: theme.palette.grey[500], fontSize: "10px" }}
                    >
                      Powered by KodaWise
                    </Typography>
                  </Box>
                )}
              </Box>

              {generatedMessage && (
                <Box mt={3}>
                  <Typography variant="h3" gutterBottom>Generated Message:</Typography>
                  <Box display="flex" justifyContent="space-between" position="relative">
                    <pre style={{ fontFamily: 'inherit', whiteSpace: 'pre-wrap' }}>{generatedMessage}</pre>
                    <IconButton
                      color="secondary"
                      component="span"
                      onClick={copyToClipboard}
                      size="small"
                      style={{ position: 'absolute', right: 0, top: -37 }}
                    > 
                      <FileCopyIcon />
                      {!isMobile && <Typography align="center">Copy Message</Typography>}
                    </IconButton>
                  </Box>
                </Box>
              )}
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}

export default Replier;